export const LOADER_LINEAR_Z_INDEX = 99_999_999;
